/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignRoleToUserRequestDto,
  CreateOrganizationUserRequestDto,
  CreateOrganizationUserResponseDto,
  ListOrganizationUsersDto,
  UpdateUserRequestDto,
} from '../models/index';
import {
    AssignRoleToUserRequestDtoFromJSON,
    AssignRoleToUserRequestDtoToJSON,
    CreateOrganizationUserRequestDtoFromJSON,
    CreateOrganizationUserRequestDtoToJSON,
    CreateOrganizationUserResponseDtoFromJSON,
    CreateOrganizationUserResponseDtoToJSON,
    ListOrganizationUsersDtoFromJSON,
    ListOrganizationUsersDtoToJSON,
    UpdateUserRequestDtoFromJSON,
    UpdateUserRequestDtoToJSON,
} from '../models/index';

export interface OrganizationUserControllerAssignRoleRequest {
    userId: string;
    organizationId: string;
    assignRoleToUserRequestDto: AssignRoleToUserRequestDto;
}

export interface OrganizationUserControllerCreateOrganizationUserRequest {
    organizationId: string;
    createOrganizationUserRequestDto: CreateOrganizationUserRequestDto;
}

export interface OrganizationUserControllerDeleteRequest {
    userId: string;
    organizationId: string;
}

export interface OrganizationUserControllerListOrganizationUsersRequest {
    organizationId: string;
    includeSuborganizations?: boolean;
    role?: OrganizationUserControllerListOrganizationUsersRoleEnum;
}

export interface OrganizationUserControllerUpdateRequest {
    userId: string;
    organizationId: string;
    updateUserRequestDto: UpdateUserRequestDto;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     */
    async organizationUserControllerAssignRoleRaw(requestParameters: OrganizationUserControllerAssignRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling organizationUserControllerAssignRole().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationUserControllerAssignRole().'
            );
        }

        if (requestParameters['assignRoleToUserRequestDto'] == null) {
            throw new runtime.RequiredError(
                'assignRoleToUserRequestDto',
                'Required parameter "assignRoleToUserRequestDto" was null or undefined when calling organizationUserControllerAssignRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/users/{userId}/role`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AssignRoleToUserRequestDtoToJSON(requestParameters['assignRoleToUserRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async organizationUserControllerAssignRole(requestParameters: OrganizationUserControllerAssignRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.organizationUserControllerAssignRoleRaw(requestParameters, initOverrides);
    }

    /**
     */
    async organizationUserControllerCreateOrganizationUserRaw(requestParameters: OrganizationUserControllerCreateOrganizationUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrganizationUserResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationUserControllerCreateOrganizationUser().'
            );
        }

        if (requestParameters['createOrganizationUserRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createOrganizationUserRequestDto',
                'Required parameter "createOrganizationUserRequestDto" was null or undefined when calling organizationUserControllerCreateOrganizationUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/users`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationUserRequestDtoToJSON(requestParameters['createOrganizationUserRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrganizationUserResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationUserControllerCreateOrganizationUser(requestParameters: OrganizationUserControllerCreateOrganizationUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrganizationUserResponseDto> {
        const response = await this.organizationUserControllerCreateOrganizationUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationUserControllerDeleteRaw(requestParameters: OrganizationUserControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling organizationUserControllerDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationUserControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/users/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async organizationUserControllerDelete(requestParameters: OrganizationUserControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.organizationUserControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async organizationUserControllerListOrganizationUsersRaw(requestParameters: OrganizationUserControllerListOrganizationUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListOrganizationUsersDto>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationUserControllerListOrganizationUsers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeSuborganizations'] != null) {
            queryParameters['includeSuborganizations'] = requestParameters['includeSuborganizations'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/users`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListOrganizationUsersDtoFromJSON));
    }

    /**
     */
    async organizationUserControllerListOrganizationUsers(requestParameters: OrganizationUserControllerListOrganizationUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListOrganizationUsersDto>> {
        const response = await this.organizationUserControllerListOrganizationUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationUserControllerUpdateRaw(requestParameters: OrganizationUserControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling organizationUserControllerUpdate().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationUserControllerUpdate().'
            );
        }

        if (requestParameters['updateUserRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateUserRequestDto',
                'Required parameter "updateUserRequestDto" was null or undefined when calling organizationUserControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/users/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRequestDtoToJSON(requestParameters['updateUserRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async organizationUserControllerUpdate(requestParameters: OrganizationUserControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.organizationUserControllerUpdateRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const OrganizationUserControllerListOrganizationUsersRoleEnum = {
    SuperAdmin: 'SUPER_ADMIN',
    OrganizationManager: 'ORGANIZATION_MANAGER',
    Supervisor: 'SUPERVISOR',
    FieldTechnician: 'FIELD_TECHNICIAN'
} as const;
export type OrganizationUserControllerListOrganizationUsersRoleEnum = typeof OrganizationUserControllerListOrganizationUsersRoleEnum[keyof typeof OrganizationUserControllerListOrganizationUsersRoleEnum];
